// © Microsoft Corporation. All rights reserved.

export function getParameter(key, defaultValue = null) {
    return getHashParameter(key) || getQueryParameter(key) || defaultValue;
}

function getQueryParameter (key) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0].toLowerCase() == key.toLowerCase()) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
}
function getHashParameter(key) {
    const query = window.location.hash.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0].toLowerCase() == key.toLowerCase()) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
}

export function generateQueryStringByKeyVals(keyVals) {
    return (keyVals && Object.keys(keyVals).length > 0) ? "?" + Object.keys(keyVals).map(function (key) {
        return `${key}=${encodeURIComponent(keyVals[key])}`;
    }).join("&") : "";
}